/* PAINTRANGER - Hell-/Dunkel-Umschalter.
   Setzt die Klasse .pf-light am <html>-Element und merkt sich die Wahl
   im Browser des Besuchers. Standard ist der dunkle Modus. */
(function () {
  var KEY = 'pf-color-mode';
  var LABEL_TO_LIGHT = 'Zur hellen Ansicht wechseln';
  var LABEL_TO_DARK = 'Zur dunklen Ansicht wechseln';

  var SUN =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" focusable="false" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="4.2"/>' +
    '<path d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.4 5.4l1.6 1.6M17 17l1.6 1.6M18.6 5.4L17 7M7 17l-1.6 1.6"/>' +
    '</svg>';

  var MOON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' +
    '<path d="M20.4 14.7A8.7 8.7 0 0 1 9.3 3.6a8.7 8.7 0 1 0 11.1 11.1Z"/>' +
    '</svg>';

  function currentMode() {
    return document.documentElement.classList.contains('pf-light') ? 'light' : 'dark';
  }

  function syncButtons() {
    var mode = currentMode();
    var label = mode === 'light' ? LABEL_TO_DARK : LABEL_TO_LIGHT;
    var buttons = document.querySelectorAll('.pf-color-mode-toggle');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-label', label);
      buttons[i].setAttribute('title', label);
      buttons[i].setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    }
  }

  function setMode(mode) {
    if (mode === 'light') {
      document.documentElement.classList.add('pf-light');
    } else {
      document.documentElement.classList.remove('pf-light');
    }
    try {
      window.localStorage.setItem(KEY, mode);
    } catch (e) {}
    syncButtons();
  }

  function createButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'header__icon header__icon--color-mode pf-color-mode-toggle link focus-inset';
    button.innerHTML =
      '<span class="pf-color-mode-icon pf-color-mode-icon--sun">' + SUN + '</span>' +
      '<span class="pf-color-mode-icon pf-color-mode-icon--moon">' + MOON + '</span>';
    button.addEventListener('click', function () {
      setMode(currentMode() === 'light' ? 'dark' : 'light');
    });
    return button;
  }

  function mount() {
    var containers = document.querySelectorAll('.header__icons');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].querySelector('.pf-color-mode-toggle')) continue;
      var cart = containers[i].querySelector('.header__icon--cart');
      containers[i].insertBefore(createButton(), cart || null);
    }
    syncButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
})();
